import { Fragment, FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

type ChooseDifferentCriteriaHintStepProps = {
  translationKey: string;
};

export const ChooseDifferentCriteriaHintStep: FunctionComponent<
  ChooseDifferentCriteriaHintStepProps
> = (props: ChooseDifferentCriteriaHintStepProps) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <p
        className={"p-4 bg-[#E5E7EB] text-[#374151] rounded-md lg:w-1/2"}
        dangerouslySetInnerHTML={{ __html: t(props.translationKey) }}
      />
    </Fragment>
  );
};
